'use client';

import MenuButton from '@/components/mainNavBar/MenuButton';
import classNames from 'classnames';

import classes from './header.module.scss';

export default function SGHeader({
  children,
  openMenu,
  toggleMenu,
  className,
}: {
  children: React.ReactNode;
  openMenu: boolean;
  toggleMenu: () => void;
  className?: string;
}) {
  return (
    <header className={classNames(classes.styleGuideHeader, className)} data-testid="style-guide-header">
      <span className={classes.menuBox}>
        <MenuButton
          data-testid="style-guide-mobile-menu-button"
          light={true}
          variant="text"
          open={openMenu}
          onClick={toggleMenu}
        ></MenuButton>
      </span>
      <span>{children}</span>
    </header>
  );
}
